import { render } from "./UserBar.vue?vue&type=template&id=312b0be9"
import script from "./UserBar.vue?vue&type=script&lang=ts"
export * from "./UserBar.vue?vue&type=script&lang=ts"
script.render = render

export default script